// A cue is only saved with a real position and size (Josh, 28 Oct 2026). Four selection cues on a sandbox show were
// saved with x, y and height NaN: never drawn, yet counted, called in calling mode, and scrambling the stacking.
// Pure, so it can be tested under node.
export function cueGeometryOk(cue) {
    if (!cue) return false;
    return ['x', 'y', 'width', 'height'].every(k => Number.isFinite(cue[k]));
}

export default cueGeometryOk;



// WEBPACK FOOTER //
// ./src/lib/cue-geometry.js